import {
  colFlag,
  mxFlag,
  usFlag,
  es,
  eurFlag,
  ukFlag,
  brFlag,
  cadFlag,
  chFlag,
  jpFlag,
  hkFlag,
  cnFlag,
  auFlag,
  plFlag,
} from '../../assets';
import { Currency, Language } from './types';

// eslint-disable-next-line import/prefer-default-export
export const COUNTRY_FLAG_LANGUAGE: Record<Language, JSX.Element> = {
  ES: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={es} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  EN: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={usFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
};

export const COUNTRY_FLAG_ICON: Record<Currency, JSX.Element> = {
  MXN: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={mxFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  USD: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={usFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  COP: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={colFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  EUR: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={eurFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  GBP: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={ukFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  CAD: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={cadFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  HKD: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={hkFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  JPY: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={jpFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  CHF: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={chFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  BRL: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={brFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  CNY: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={cnFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  AUD: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={auFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
  PLN: (
    <div className="rounded-full w-[18px] h-[18px] overflow-hidden flex items-center justify-center mr-2">
      <img src={plFlag} alt="mx-flag" className="w-auto max-w-fit h-full" />
    </div>
  ),
};
